import React from 'react'
import { connect } from 'react-redux'
import { TidewaysContext } from '../app/context'
import Link from '../helper/link'
import { ApplicationState } from '../redux/ApplicationState'

interface OwnProps {
    active: string
}

interface StateProps {
    tidewaysContext: TidewaysContext
}

type Props = OwnProps & StateProps

class Application extends React.Component<Props> {
    public render() {
        const hasMonitoring = this.props.tidewaysContext.application && this.props.tidewaysContext.application.monitoring
        const active = this.props.active || null

        let links = [
            { name: 'performance', route: 'XhprofOrganizationBundle.Application.show', supportsAllServices: false, extraParams: {} },
            { name: 'traces', route: 'XhprofProfilerBundle.Profile.list', extraParams: { hours: 24 } },
            { name: 'issues', route: 'XhprofErrorBundle.Issues.errors', extraParams: {} },
            { name: 'history', route: 'XhprofProfilerBundle.History.lastWeek', supportsAllServices: false, extraParams: {} },
            { name: 'settings', route: 'XhprofOrganizationBundle.Application.settings', supportsAllServices: false, extraParams: {} },
        ]

        if (!hasMonitoring) {
            links = [
                { name: 'traces', route: 'XhprofProfilerBundle.Profile.list', extraParams: { hours: 24 } },
                { name: 'settings', route: 'XhprofOrganizationBundle.Application.settings', supportsAllServices: false, extraParams: {} },
            ]
        }

        return (
            <ul className="nav navbar-nav">
                <li className="logo-nav">
                    <a href={'/dashboard?current=' + this.props.tidewaysContext.organization?.name}>
                        <img src="/assets/img/tideways-small.png" alt="Dashboard" width="18" height="18" />
                    </a>
                </li>
                {this.props.tidewaysContext.organization && this.props.tidewaysContext.application ? (
                    <li className="merged">
                        <Link route="dashboard" params={{ current: this.props.tidewaysContext.organization.name }}>
                            {this.props.tidewaysContext.organization.name}
                        </Link>{' '}
                        /
                        <Link route="XhprofOrganizationBundle.Application.show" supportsAllServices={false} params={{}}>
                            {this.props.tidewaysContext.application.name}
                        </Link>
                    </li>
                ) : (
                    ''
                )}
                {links.map(({ name, route, supportsAllServices, extraParams }) =>
                    name === 'settings' ? (
                        <li key={name} className="dropdown">
                            <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
                                {name.charAt(0).toUpperCase() + name.slice(1)} <span className="caret" />
                            </a>

                            <ul className="dropdown-menu" role="menu">
                                <li>
                                    <Link route={route} skipHistoryApi>
                                        Overview
                                    </Link>
                                </li>
                                <li>
                                    <div className="divider" />
                                </li>
                                <li>
                                    <Link route={route} skipHistoryApi>
                                        General Settings
                                    </Link>
                                </li>
                                {hasMonitoring ? (
                                    <li>
                                        <Link route={'XhprofErrorBundle.Error.listExceptionTracking'} skipHistoryApi>
                                            Exception Tracking
                                        </Link>
                                    </li>
                                ) : null}
                                <li>
                                    <Link route={'XhprofProfilerBundle.Environment.list'} skipHistoryApi>
                                        Environments
                                    </Link>
                                </li>
                                <li>
                                    <Link route={'XhprofProfilerBundle.Server.list'} skipHistoryApi>
                                        Servers
                                    </Link>
                                </li>
                                <li>
                                    <Link route={'XhprofProfilerBundle.Service.list'} skipHistoryApi>
                                        Services
                                    </Link>
                                </li>
                                <li>
                                    <Link route={'XhprofProfilerBundle.Transaction.list'} skipHistoryApi>
                                        Transactions
                                    </Link>
                                </li>
                                {hasMonitoring ? (
                                    <li>
                                        <Link route={'XhprofAlertBundle.Configuration.list'} skipHistoryApi>
                                            Notifications
                                        </Link>
                                    </li>
                                ) : null}
                                <li>
                                    <Link route={'XhprofOrganizationBundle.Application.installation'} skipHistoryApi>
                                        Setup
                                    </Link>
                                </li>
                                <li>
                                    <Link route={'XhprofOrganizationBundle.Application.license'} skipHistoryApi>
                                        License
                                    </Link>
                                </li>
                                <li>
                                    <Link route={route} anchor={'#ExportsIntegrations'} skipHistoryApi>
                                        Exports &amp; Integrations
                                    </Link>
                                </li>
                                <li>
                                    <Link route={route} anchor={'#TeamAccess'} skipHistoryApi>
                                        Team Access
                                    </Link>
                                </li>
                                {!this.props.tidewaysContext.isAdmin ? (
                                    ''
                                ) : (
                                    <li>
                                        <Link route={route} anchor={'#dangerZone'} skipHistoryApi>
                                            Danger Zone
                                        </Link>
                                    </li>
                                )}
                            </ul>
                        </li>
                    ) : (
                        <li key={name} className={active === name ? 'active' : ''}>
                            <Link route={route} params={extraParams} supportsAllServices={supportsAllServices}>
                                {name.charAt(0).toUpperCase() + name.slice(1)}
                            </Link>
                        </li>
                    ),
                )}
            </ul>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    return {
        ...props,
        tidewaysContext: globalState.tidewaysContext,
    }
})(Application)
